export default __webpack_public_path__ + "img/check.c176569.svg";